import { Divider, Form, Input, Spin, Table } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { save } from "../../../../../features/save/saveSlice";
import svg44 from "../../../../../assets/svg/svg44.svg";
import svg59 from "../../../../../assets/svg/svg59.svg";
import svg85 from "../../../../../assets/svg/svg85.svg";
import svg92 from "../../../../../assets/svg/svg92.svg";
import svg76 from "../../../../../assets/svg/svg76.svg";
import deleteSvg from "../../../../../assets/svg/delete-red.svg";
import toast from "react-hot-toast";
import useModalToggle from "../../../../../custom_hooks/useModalToggle";
import DocumentAdd from "./DocumentAdd";
import ConfirmModal from "../../../../../components/ConfirmModal";
import {
  fetchData,
  fetchFilesSecured,
} from "../../../../../features/dropdown/dropdownSlice";
import { previewPaperApplicant } from "../../../../../utils";
import { deleteDoc } from "../../../../../features/folder/folderSlice";

function DocumentTable({
  handleNext,
  handleBack,
  handleSubmitStep,
  handlePrev,
  review,
  dataView,
}) {
  const { open, handleCancel, handleOpen } = useModalToggle();
  const { docs } = useSelector((state) => state.folder);
 
  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [prodd1, setProdd1] = useState();

  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleDelete = async () => {};

  const downloadFile = async (item) => {
    try {
      const res = await dispatch(fetchFilesSecured({ file: item }));
      if (res?.payload) {
        window.open(res.payload, "_blank");
      }
    } catch (error) {
      console.error("Failed to open file:", error);
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "docName",
    },
    {
      title: "Actions",
      width: "10px",
      align: "right",
      render: (item, record, index) => {
        return (
          <div
            className="flex items-center gap-x-[.62rem]"
            onClick={() => setProdd(item)}
          >
            <img
              src={svg59}
              alt="svg59"
              className="cursor-pointer"
              onClick={() => previewPaperApplicant(item?.docFile)}
            />
            {!review && (
              <img
                className="cursor-pointer"
                src={deleteSvg}
                alt="deleteSvg"
                onClick={() => dispatch(deleteDoc(index))}
              />
            )}
          </div>
        );
      },
    },
  ];

  const handleAdd = async () => {
    await handleOpen();
  };

  return (
    <>
      <div className="flex  flex-col gap-[1.25rem]  ">
        <div className="flex lg:flex-row flex-col-reverse lg:items-center justify-between lg:mt-[.25rem] gap-y-4">
          <div
            className={`${
              review
                ? "text-[#000] text-[1rem] mt-[1rem]"
                : "text-lightBlack text-[1.125rem] font-dmSans font-500"
            } `}
          >
            Other Relevant Documents
          </div>

          {!review && (
            <div className="w-[120px]">
              <button
                type="button"
                onClick={() => handleAdd()}
                className="cstm-btn"
              >
                <img src={svg76} alt="svg76" />{" "}
                <span className="ml-1">Upload</span>
              </button>
            </div>
          )}
        </div>
        <div className="w-full">
          <Table
            rowSelection={false}
            className="w-full"
            scroll={{
              x: "auto",
            }}
            columns={columns}
            dataSource={dataView}
            rowKey={(record, index) => index}
            pagination={false}
          />
        </div>
      </div>

      {!review && (
        <div className="flex lg:flex-row flex-col lg:items-center justify-between lg:gap-0  gap-5   w-full mt-[2.5rem]">
          <div
            className="flex items-center text-[#706F6F] text-[.875rem] font-[400] font-dmSans gap-3 cursor-pointer"
            onClick={handlePrev}
          >
            <img src={svg85} alt="svg85" /> Back
          </div>
          <div className="justify-end flex items-center gap-x-2">
            <div className="w-[100px]">
              <button
                key="back"
                type="button"
                className="cstm-btn-2"
                onClick={handlePrev}
              >
                Cancel
              </button>
            </div>

            <div className="w-[250px]">
              <button
                key="submit"
                type="submit"
                className="cstm-btn"
                onClick={handleSubmitStep}
              >
                <span className="flex items-center  gap-x-3 ">
                  Save And Proceed <img src={svg92} alt="svg92" />
                </span>
              </button>
            </div>
          </div>
        </div>
      )}

      <DocumentAdd
        isModalOpen={open}
        handleCancel={handleCancel}
        prodd={prodd}
        prodd1={prodd1}
      />

      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        content="Are you sure you want perfom this action?"
        type="alert"
        btnTitle="Delete"
      />
    </>
  );
}

export default DocumentTable;
